module.exports = __webpack_public_path__ + "static/img/6.97d5d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-salud/6.png
// module id = kaY1
// module chunks = 0